import { Loader2, MessageSquare } from 'lucide-react';
import type { SimulationBatch } from '@/types/evaluator';
import { DataSurface } from '@/components/platform/DataSurface';
import { isRunningStatus } from '../utils';

export function ResultsEmptyState({
  selectedRun,
}: {
  selectedRun: SimulationBatch | null;
}) {
  const isRunning = selectedRun ? isRunningStatus(selectedRun.status) : false;
  const isFailed = selectedRun ? selectedRun.status.toLowerCase().includes('fail') : false;
  const hasPopulations = (selectedRun?.dataset_names?.length ?? 0) > 0;

  const title = (() => {
    if (isRunning) return 'Hobbes is generating conversations';
    if (isFailed) return 'This simulation did not finish';
    if (!hasPopulations) return 'No personas were included';
    return 'No generated conversations';
  })();

  const body = (() => {
    if (isRunning) return 'Refresh shortly to review conversations as soon as they are available.';
    if (isFailed) return 'Start a new simulation or select a previous run from History.';
    if (!hasPopulations) return 'Choose a run with personas, or generate personas before running the next simulation.';
    return 'This run has not produced conversation transcripts yet.';
  })();

  return (
    <DataSurface>
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        {isRunning ? <Loader2 className="h-7 w-7 animate-spin text-muted-foreground" /> : <MessageSquare className="h-8 w-8 text-muted-foreground" />}
        <div>
          <p className="text-sm font-medium text-foreground">{title}</p>
          <p className="mt-1 max-w-sm text-sm text-muted-foreground">{body}</p>
        </div>
      </div>
    </DataSurface>
  );
}
